import * as React from "react";
import styled from "styled-components";

import { Jumbotron } from "@ui/Molecules/Jumbotron";
import { Container } from "@ui/Atoms/Grid";
import theme from "@ui/themes/default";
import { rem } from "@ui/helpers";

import { PrismicImageField } from "@www/graphql-types";

export interface HeadData {
  // contenful data
  headTitle?: string;
  headText?: string;
  headButtonText?: string;
  headButtonLink?: string;
  headBackgroundImage?: {
    file: {
      url: string;
    };
  };
  headBackgroundImageMobile?: {
    file: {
      url: string;
    };
  };

  // prismic data
  hero_title?: { text: string };
  hero_description?: { text: string };
  hero_action_button?: { text: string };
  hero_action_button_link?: { text: string };
  hero_image?: PrismicImageField;
  hero_image_mobile?: PrismicImageField;
}

interface Props {
  data: HeadData;
}

const renderJumbotron = (data: HeadData) => (
  <Jumbotron
    title={data.hero_title?.text || data.headTitle || ""}
    content={data.hero_description?.text || data.headText || ""}
    btnText={data.hero_action_button?.text || data.headButtonText || ""}
    btnHref={data.hero_action_button_link?.text || data.headButtonLink || ""}
  />
);

const Head = ({ data }: Props): React.ReactElement => (
  <React.Fragment>
    <Background
      backgroundImage={
        data.hero_image?.gatsbyImageData?.images?.fallback?.src ||
        data.headBackgroundImage?.file.url ||
        ""
      }
      backgroundImageMobile={
        data.hero_image_mobile?.gatsbyImageData?.images?.fallback?.src ||
        data.headBackgroundImageMobile?.file.url ||
        ""
      }
    >
      <Container>
        <WelcomeJumbotron>{renderJumbotron(data)}</WelcomeJumbotron>
      </Container>
    </Background>
    <MobileBackground>
      <Container>{renderJumbotron(data)}</Container>
    </MobileBackground>
  </React.Fragment>
);

export { Head };

const MobileBackground = styled.div`
  position: relative;
  margin-top: -${theme.margins.base_x8};

  ${theme.breakpoints.tablet} {
    margin-top: calc(-${theme.margins.base_x8}*4);
  }

  ${theme.breakpoints.desktop} {
    display: none;
  }
`;

const WelcomeJumbotron = styled.div`
  display: none;

  ${theme.breakpoints.desktop} {
    position: relative;
    display: block;
    margin: 0;
    transform: translateY(0);
  }
`;

const Background = styled.div<{
  backgroundImage: string;
  backgroundImageMobile: string;
}>`
  position: relative;
  /* Padding top is adjusted exactly to the image with size: 768 x 667 */
  padding-top: 87%;

  background-image: url(${props => props.backgroundImageMobile});
  background-position: top;
  background-size: cover;

  ${theme.breakpoints.desktop} {
    padding-top: ${theme.margins.base_x4};
    background-image: url(${props => props.backgroundImage});
    min-height: ${rem(580)};
  }
`;
